import type { InfiniteScrollCustomEvent } from '@ionic/angular';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { NinetyNotification, NotificationListResponse } from '../models/ninety-notification.model';
import { NotificationFilterOptions } from '../models/notification-filter-options';

export const NotificationFeedActions = createActionGroup({
  source: 'Notification Feed',
  events: {
    Init: emptyProps(),
    'Init Success': props<{ resp: NotificationListResponse; unreadStatusIndicator: boolean }>(),
    Open: emptyProps(),

    'Get User Notifications Success': props<{ resp: NotificationListResponse; event?: CustomEvent }>(),
    'Get User Notifications Failure': props<{ error: unknown; event?: CustomEvent }>(),

    'Load More Notifications': props<{ event?: InfiniteScrollCustomEvent }>(),
    'Load More Notifications Success': props<{ resp: NotificationListResponse; event?: InfiniteScrollCustomEvent }>(),
    'Load More Notifications Failure': props<{ error: unknown; event?: InfiniteScrollCustomEvent }>(),

    'Toggle Notification Read Status': props<{ notification: NinetyNotification }>(),
    'Mark Notifications As Read': props<{ ids: number[] }>(),
    'Mark Notification As Unread': props<{ id: number }>(),
    'Mark All As Read': emptyProps(),

    'Set Filter Option': props<{ filterBy: NotificationFilterOptions }>(),
    'Refresh Feed': props<{ event?: CustomEvent }>(),

    'Open Item Detail': props<{ notification: NinetyNotification }>(),
  },
});
